import React, { useState, useEffect } from 'react';
import './VisitorCounter.css';

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define API URL - replace with your actual backend URL if not using environment variables
  const API_URL = process.env.REACT_APP_API_URL || 'https://dibyanjaya.me';
  
  useEffect(() => {
    // Function to track the visit
    const trackVisit = async () => {
      try {
        console.log('Attempting to track visit at:', `${API_URL}/visitor/track`);
        
        const response = await fetch(`${API_URL}/visitor/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userAgent: navigator.userAgent,
            page: window.location.pathname
          })
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Server returned error:', response.status, errorText);
          throw new Error(`Server error: ${response.status}`);
        }

        const data = await response.json();
        console.log('Visit tracked successfully:', data);
        
        if (data.success) {
          setVisitorCount(data.totalVisits);
          setLoading(false);
        } else {
          throw new Error(data.message || 'Failed to track visit');
        }
      } catch (error) {
        console.error('Error tracking visit:', error);
        setError(`Failed to track: ${error.message}`);
        // Fallback to just getting the count
        getVisitorCount();
      }
    };

    // Function to get visitor count without tracking
    const getVisitorCount = async () => {
      try {
        console.log('Attempting to get visitor count at:', `${API_URL}/visitor/count`);
        
        const response = await fetch(`${API_URL}/visitor/count`);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Server returned error:', response.status, errorText);
          throw new Error(`Server error: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('Visitor count response:', data);
        
        if (data.success) {
          setVisitorCount(data.count);
        } else {
          throw new Error(data.message || 'Failed to get visitor count');
        }
        setLoading(false);
      } catch (error) {
        console.error('Error getting visitor count:', error);
        setError(`Failed to get count: ${error.message}`);
        setLoading(false);
      }
    };

    // Track the visit when component mounts
    trackVisit();
    
    // We only want this to run once when the component mounts
  }, [API_URL]);

  if (error) {
    console.warn('Visitor counter error:', error);
  }

  return (
    <div className="visitor-counter">
      {loading ? (
        <span>Loading...</span>
      ) : error ? (
        <span title={error}><i className="fas fa-eye"></i> --</span>
      ) : (
        <span>
          <i className="fas fa-eye"></i> {visitorCount.toLocaleString()} visits
        </span>
      )}
    </div>
  );
};

export default VisitorCounter;